import React, { useEffect, useState, useRef, useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo2 from "../images/logo5.jpg";
import notificationSound from "../assets/new.notification.mp3.mp3";
import axios from "axios";
import { API } from "../utils/apk";
import { ThemeContext } from "./ThemeContext";

function Navbar({ stopNotificationSoundRef }) {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [orders, setOrders] = useState([]);
  const [highlightOrdersTab, setHighlightOrdersTab] = useState(false);
  const [logoUrl, setLogoUrl] = useState(null);
  const audioRef = useRef(null);
  const location = useLocation();
  const prevOrderIdsRef = useRef([]);
  const hasInitializedRef = useRef(false);
const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    audioRef.current = new Audio(notificationSound);
    audioRef.current.load();
  }, []);

  const playSound = () => {
    if (audioRef.current) {
      audioRef.current.play().catch((e) => {
        console.warn("Audio play blocked:", e);
      });
    }
  };

  const stopSound = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
  };

  if (stopNotificationSoundRef) {
    stopNotificationSoundRef.current = stopSound;
  }

  const showDesktopNotification = (title, body) => {
    if ("Notification" in window && Notification.permission === "granted") {
      new Notification(title, { body });
    }
  };

  const fetchOrders = async () => {
    try {
      const response = await axios.get(`${API}/get/all/order`);
      const newOrders = response.data.data || [];
      const newOrderIds = newOrders.map((o) => o._id);

      if (hasInitializedRef.current) {
        const newOnes = newOrderIds.filter(
          (id) => !prevOrderIdsRef.current.includes(id)
        );

        if (newOnes.length > 0 && location.pathname !== "/Orders") {
          playSound();
          setHighlightOrdersTab(true);

          if (document.hidden || !document.hasFocus()) {
            showDesktopNotification(
              "🛒 New Order Received",
              "Check the Orders tab."
            );
          }
        }
      } else {
        hasInitializedRef.current = true;
      }

      prevOrderIdsRef.current = newOrderIds;
      setOrders(newOrders);
    } catch (err) {
      console.error("❌ Error fetching orders", err);
    }
  };

  useEffect(() => {
    if ("Notification" in window && Notification.permission !== "granted") {
      Notification.requestPermission();
    }

    fetchOrders();
    const interval = setInterval(fetchOrders, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (location.pathname === "/Orders") {
      setHighlightOrdersTab(false);
      stopSound();
    }
  }, [location.pathname]);

  useEffect(() => {
    const adminId = localStorage.getItem("adminId");
    if (!adminId) return;

    const fetchLogo = async () => {
      try {
        const res = await axios.get(`${API}/get/all/business`);
        const image = res?.data?.data?.[0]?.image;
        if (image) setLogoUrl(image);
      } catch (err) {
        console.error("Error fetching logo image:", err);
      }
    };

    fetchLogo();
  }, []);

useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  return (
    <nav className="bg-blue-900 dark:bg-gray-900 w-full">
      {/* Marquee */}
      <div className="bg-blue-900 dark:bg-gray-900 overflow-hidden whitespace-nowrap">
        <p className="text-white dark:text-yellow-300 font-medium animate-marquee">
          Developed by - TDR Software Pvt Ltd .. Contact No - 9830657184
        </p>
      </div>

      {/* Main Nav */}
      <div className="flex items-center justify-between px-2">
        {/* Left Logo */}
        <div>
          {logoUrl && (
            <img
              src={logoUrl}
              alt="Business Logo"
              className="h-14 w-14 rounded-full object-cover border-2 border-red-500 shadow"
            />
          )}
        </div>

        {/* Mobile Toggle */}
        <button
          className="text-white dark:text-yellow-300 md:hidden focus:outline-none"
          onClick={toggleMenu}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"}
            />
          </svg>
        </button>

        {/* Menu Links */}
        <div
          className={`${
            isMenuOpen ? "block" : "hidden"
          } md:flex md:items-center md:space-x-4 md:static absolute top-0 left-0 w-full bg-blue-900 dark:bg-gray-900 md:bg-transparent md:w-auto z-50 px-0 md:px-0`}
        >
          <ul className="flex flex-col md:flex-row md:space-x-4 space-y-1 md:space-y-0 items-center">
            {[
              { to: "/", label: "DashBoard" },
              { to: "/register", label: "Register" },
              { to: "/offer", label: "Offer" },
              { to: "/Orders", label: "Orders", special: true },
              { to: "/add-business", label: "Business" },
              { to: "/Assigned", label: "Assigned" },
              { to: "/Confirmed", label: "Delivered" },
              { to: "/addDeliveryBoy", label: "Add Delivery" },
              { to: "/mapDeliveryBoy", label: "Track Delivery" },
              { to: "/logout", label: "Logout" },
            ].map(({ to, label, special }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    `px-5 rounded-md font-bold border-2 text-sm whitespace-nowrap ${
                      isActive
                        ? "text-green-400 border-green-400"
                        : special && highlightOrdersTab
                        ? "text-red-500 border-red-500 animate-pulse"
                        : "text-white hover:text-red-400 dark:text-yellow-200 dark:hover:text-red-300 border-transparent"
                    }`
                  }
                >
                  {label}
                </NavLink>
              </li>
            ))}

            {/* Report Dropdown */}
            <li className="relative" ref={dropdownRef}>
      {/* CLICK TO OPEN */}
      <span
        className="px-5 rounded-md font-bold text-sm text-white cursor-pointer hover:text-red-400"
        onClick={() => setOpen(!open)}
      >
        Report ▼
      </span>

      {/* DROPDOWN */}
      {open && (
        <ul className="absolute bg-blue-800 text-white rounded-md shadow-md z-50 min-w-max mt-2">
          <li>
            <NavLink
              to="/cancel-report"
              className="block px-4 py-2 text-sm hover:bg-blue-700"
              onClick={() => setOpen(false)}  // CLOSE ON CLICK
            >
              Cancel Report
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/report"
              className="block px-4 py-2 text-sm hover:bg-blue-700"
              onClick={() => setOpen(false)} // CLOSE ON CLICK
            >
              Sale Report
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/delivery-report"
              className="block px-4 py-2 text-sm hover:bg-blue-700"
              onClick={() => setOpen(false)} // CLOSE ON CLICK
            >
              Delivery Boy Report
            </NavLink>
          </li>
        </ul>
      )}
    </li>

            {/* Dark Mode Toggle */}
            <li>
              <button
                onClick={toggleTheme}
                className="text-white dark:text-yellow-300 text-xl px-3"
                title="Toggle Theme"
              >
                {theme === "dark" ? "☀️" : "🌙"}
              </button>
            </li>

            {/* Right Logo */}
            <li>
              <img
                src={logo2}
                alt="Logo2"
                className="h-14 w-14 rounded-full object-cover border-2 border-red-500 shadow"
              />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
